import { render, staticRenderFns } from "./jingnei.vue?vue&type=template&id=18465a6a"
import script from "./jingnei.vue?vue&type=script&lang=js"
export * from "./jingnei.vue?vue&type=script&lang=js"
import style0 from "./jingnei.vue?vue&type=style&index=0&id=18465a6a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports